export default __webpack_public_path__ + "static/media/Acc.83e2c6b4.png";